import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Spinner } from 'triider-components';

import { ButtonBack } from 'components/Button';
import { history } from '../../store';
import {
  Container, HeaderPage, TitlePage, Content, ContentCard, ContentSpinner,
} from './styles';
import CardService from '../../components/CardService';
import { Creators as FormCreators } from '../../store/ducks/serviceForm';
import { Creators as ServiceCreators } from '../../store/ducks/services';

function Services() {
  const dispatch = useDispatch();
  const { categoryId } = useParams();

  const loadingServices = useSelector(state => state.ui.loaders.includes('SERVICES'));
  const servicesSelected = useSelector(state => state.services.servicesSelected);
  const categories = useSelector(state => state.categories.data);
  const categorySelected = categories.find(category => category.id === Number(categoryId));

  const companySource = useSelector(state => state.company.data.source);
  const companyId = useSelector(state => state.company.data.id);

  function _openServiceForm(payload) {
    dispatch(FormCreators.openForm(payload));
  }

  useEffect(() => {
    dispatch(ServiceCreators.getServiceByCategoryRequest(categoryId));
  }, [categoryId]);

  return (
    <Container>
      <Content>
        <HeaderPage>
          <ButtonBack type="button" onClick={() => history.goBack()}>
            <span>Voltar</span>
          </ButtonBack>
          <TitlePage>
            {categorySelected
            && categorySelected.name && categorySelected.name
              .toString()
              .toLowerCase()
              .includes('serviços')
              ? ''
              : 'Serviços de '}
            <b>
              &nbsp;
              {categorySelected.name}
            </b>
          </TitlePage>
        </HeaderPage>
        {loadingServices ? (
          <ContentSpinner>
            <Spinner size="larger" />
          </ContentSpinner>
        ) : (
          <ContentCard>
            {servicesSelected
              && servicesSelected.map(service => (
                <CardService
                  openForm={() => _openServiceForm({
                    open: true,
                    isOpen: true,
                    source: companySource,
                    company_id: companyId,
                    serviceId: service.id,
                  })
                  }
                  service={service}
                  key={service.id}
                />
              ))}
          </ContentCard>
        )}

      </Content>
    </Container>
  );
}

export default Services;
